import { render } from "./Vms.vue?vue&type=template&id=d20df75a&scoped=true"
import script from "./Vms.vue?vue&type=script&lang=js"
export * from "./Vms.vue?vue&type=script&lang=js"

import "./Vms.vue?vue&type=style&index=0&id=d20df75a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20df75a"]])

export default __exports__